import CircularMotionScreenSJ2D from './CircularMotionScreenSJ2D.png';
import CircularMotionScreenSJ2D2 from './CircularMotionScreenSJ2D_2.png';
import CircularMotionScreenSJ3D from './CircularMotionScreenSJ3D.png';
import CircularMotionScreenSJ3D2 from './CircularMotionScreenSJ3D_2.png';
import CircularMotionScreenSA3D from './CircularMotionScreenSA3D.png';
import CircularMotionScreenSA3D2 from './CircularMotionScreenSA3D_2.png';
import CircularMotionScreenSA4D from './CircularMotionScreenSA4D.png';
import CircularMotionScreenSA4D2 from './CircularMotionScreenSA4D_2.png';

export const getImageCircularMotionScreen = (decks: number, model: string) => {
  if (model.charAt(1) === 'A') {
    switch (decks) {
      case 2:
        return CircularMotionScreenSA3D;
      case 3:
        return CircularMotionScreenSA3D;
      case 4:
        return CircularMotionScreenSA4D;
      default:
        return CircularMotionScreenSA3D;
    }
  } else {
    switch (decks) {
      case 2:
        return CircularMotionScreenSJ2D;
      case 3:
        return CircularMotionScreenSJ3D;
      default:
        return CircularMotionScreenSJ2D;
    }
  }
};

export const getImageCircularMotionScreen2 = (decks: number, model: string) => {
  if (model.charAt(1) === 'A') {
    switch (decks) {
      case 3:
        return CircularMotionScreenSA3D2;
      case 4:
        return CircularMotionScreenSA4D2;
      default:
        return CircularMotionScreenSA3D2;
    }
  } else {
    switch (decks) {
      case 2:
        return CircularMotionScreenSJ2D2;
      case 3:
        return CircularMotionScreenSJ3D2;
      default:
        return CircularMotionScreenSJ2D2;
    }
  }
};
